import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { Chip } from "@components/ui/Chip"
import { FilmTileFragment } from "@generated-types"
import { Link } from "eddev/routing"

type Props = {
  film: FilmTileFragment
}

export function MiniFilmResult(props: Props) {
  return (
    <Link className="flex flex-col gap-2" href={props.film.uri}>
      <ResponsiveImage aspect={16 / 9} {...props.film.media?.thumb} className="rounded-sm overflow-hidden" />
      <p className="type-ui-s">{props.film.title}</p>
      <div>
        <Chip shape="rounded" variant="high">
          {props.film.eventInfo?.eventType}
        </Chip>
      </div>
    </Link>
  )
}
